import Vue from 'vue'

import {
  FETCH_EXHIBITION_GROUP_TYPE,
  SET_EXHIBITION_GROUP_TYPE,
  FETCH_EXHIBITION_GROUPS,
  SET_EXHIBITION_GROUPS,
  FETCH_COUNTRIES,
  SET_COUNTRIES
} from './actions'

const mutations = {
  [FETCH_EXHIBITION_GROUP_TYPE] (state, payload) {
    Vue.set(state, 'loading', true)
  },
  [SET_EXHIBITION_GROUP_TYPE] (state, payload) {
    Vue.set(state, 'loading', false)
    Vue.set(state, 'exhibitionGroups', payload.results)
  },
  [FETCH_EXHIBITION_GROUPS] (state, payload) {
    Vue.set(state, 'loading', true)
  },
  [SET_EXHIBITION_GROUPS] (state, payload) {
    Vue.set(state, 'loading', false)
    Vue.set(state, 'exhib_groups', payload.results)
  },
  [FETCH_COUNTRIES] (state, payload) {
    Vue.set(state, 'loading', true)
  },
  [SET_COUNTRIES] (state, payload) {
    Vue.set(state, 'loading', false)
    Vue.set(state, 'countries', payload.results)
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/glossary/mutations.js